// SpecRef: ARCH-003
// See: docs/decisions/ARCH-003-wind-heatmap-color-themes.md#unit-support
// Wind speed unit conversion utilities (display-only).

// eslint-disable-next-line import-x/no-internal-modules
import type { WindSpeedUnit } from '../model/types';

const MS_TO_KNOTS = 1.94384;

export const msToKnots = (ms: number): number => ms * MS_TO_KNOTS;

export const knotsToMs = (knots: number): number => knots / MS_TO_KNOTS;

export const LEGEND_MAX = 35;

/** Legend speed labels per unit. Values are rounded for clean display. */
export const LEGEND_SPEEDS: Record<WindSpeedUnit, readonly number[]> = {
  ms: [0, 3, 5, 10, 15, 20, 30],
  knots: [0, 6, 10, 19, 29, 39, 58],
};

export const UNIT_LABELS: Record<WindSpeedUnit, string> = {
  ms: 'm/s',
  knots: 'kt',
};
